<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <h4 class="mt-2 text-center text-bold">
      ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ
    </h4>
    <h4 class="mt-2 text-center text-bold">
      ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນາຖາວອນ
    </h4>
    <br />
    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-5"></div>
          <div class="col-md-2">
            <h1 class="text-center" style="color: #54c392"><b>Daily</b></h1>
            <br /><br />
            <!-- <img src="image/logo.jpg" alt="Logo" class="w-50 h-100 rounded-circle">   -->
          </div>
          <div class="col-md-5"></div>
        </div>
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-2">
            <h5 class="text-bold">ຊື່ຜູ້ດູແລ: ແອັດມິນ</h5>
          </div>
          <div class="col-md-4">
            <h2 class="text-center text-bold" style="color: #54c392">
              ໃບບິນລາຍຮັບ
            </h2>
          </div>
          <div class="col-md-3">
            <h6 class="text-bold" id="datetime">
              <date-time-component></date-time-component>
            </h6>
          </div>
        </div>
        <br />
        <div class="row">
          <!-- left column -->
          <div class="col-md-1"></div>
          <!--/.col (left) -->
          <!-- right column -->
          <div class="col-md-10" style="overflow: auto">
            <div class="d-flex justify-content-between">
              <div></div>
              <div class="d-flex">
                <div class="mx-1">
                  <button
                    style="background-color: #54c392"
                    class="btn text-white mb-2"
                    @click="exportToPdf"
                  >
                    <i class="fas fa-arrow-circle-down mx-1"></i>
                    ດາວໂຫຼດ PDF
                  </button>
                </div>

                <div>
                  <button class="btn btn-success mb-2" @click="exportToExcel">
                    <i class="fas fa-arrow-circle-down mx-1"></i>
                    ດາວໂຫຼດ Excel
                  </button>
                </div>
              </div>
            </div>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ຈຳນວນເງິນ</th>
                  <th>ລາຍລະອຽດ</th>
                  <th>ສະຖານະ</th>
                  <th>ວັນທີ່ເວລາ</th>
                </tr>
              </thead>
              <template
                v-for="(yearIncomes, year) in groupedIncomes"
                :key="year"
              >
                <!-- Year Row -->
                <tr>
                  <td colspan="5" class="text-center bg-light">
                    <b>ລາຍຮັບປີ {{ year }}</b>
                  </td>

                  <td colspan="1" class="bg-light text-center">
                    <!-- PLUS -->
                    <span
                      v-if="!expandedYears[year]"
                      class="text-bold mx-2"
                      style="cursor: pointer"
                      @click="toggleYear(year)"
                    >
                      <i class="fas fa-plus"></i>
                    </span>

                    <!-- MINUS -->
                    <span
                      v-else
                      class="text-bold mx-2"
                      style="cursor: pointer"
                      @click="toggleYear(year)"
                    >
                      <i class="fas fa-minus"></i>
                    </span>
                  </td>
                </tr>

                <tr
                  v-show="expandedYears[year]"
                  v-for="(income_data, index) in yearIncomes"
                  :key="income_data.id"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <b style="color: #54c392"
                      >{{ formatNumber(income_data.income) }}₭</b
                    >
                  </td>
                  <td>
                    <b>{{ income_data.income_reason }}</b>
                  </td>
                  <td>
                    <b style="color: #54c392">{{ income_data.m_status }}</b>
                  </td>
                  <td>
                    <b style="color: #54c392">{{ income_data.timestamp }}</b>
                  </td>
                </tr>
              </template>
              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-bold">ລວມທັງໝົດ:</td>
                  <td class="text-bold" style="color: #54c392">
                    {{ formatNumber(sum_incomes) }}₭
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--/.col (right) -->

          <div class="col-md-1"></div>
        </div>

        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
  <br />
  <div class="row">
    <div class="col-md-5"></div>
    <div class="col-md-2">
      <h1 class="text-center text-bold">ຂໍຂອບໃຈ</h1>
      <!-- <img src="image/logo.jpg" alt="Logo" class="w-50 h-100 rounded-circle">   -->
    </div>
    <div class="col-md-5"></div>
  </div>
  <br /><br />
</template>
<script>
import axios from "axios";
import DateTimeComponent from "./DateTimeComponent.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export default {
  name: "PrintIncomeComponent",
  components: {
    DateTimeComponent,
  },
  watch: {
    groupedIncomes: {
      immediate: true,
      handler(val) {
        const years = Object.keys(val);
        if (years.length) {
          this.expandedYears[years[0]] = true;
        }
      },
    },
  },
  computed: {
    groupedIncomes() {
      return this.income_datas.reduce((group, income_datas) => {
        const year = new Date(income_datas.timestamp).getFullYear();

        if (!group[year]) {
          group[year] = [];
        }

        group[year].push(income_datas);
        return group;
      }, {});
    },
  },
  data() {
    return {
      income_datas: [],
      sum_incomes: 0,
      expandedYears: {},
    };
  },
  created() {
    this.fetchIncome();
    this.fetchSumIncome();
  },
  methods: {
    toggleYear(year) {
      this.expandedYears[year] = !this.expandedYears[year];
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatNumber(value) {
      if (!value) return "0";
      return Number(value).toLocaleString("en-US");
    },
    exportToExcel() {
      // Prepare data for Excel
      const dataForExcel = this.income_datas.map((item, index) => ({
        "#": index + 1,
        ຈຳນວນເງິນ: item.income,
        ລາຍລະອຽດ: item.income_reason,
        ສະຖານະ: item.m_status,
        ວັນທີ່ເວລາ: item.timestamp,
      }));

      // Add sum row
      dataForExcel.push({
        "#": "",
        ຈຳນວນເງິນ: "",
        ລາຍລະອຽດ: "",
        ສະຖານະ: "ລວມທັງໝົດ",
        ວັນທີ່ເວລາ: this.sum_incomes,
      });

      // Create a worksheet
      const ws = XLSX.utils.json_to_sheet(dataForExcel);

      // Create a workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Income");

      // Export to file
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "income.xlsx"
      );
    },
    exportToPdf() {
      window.print();
    },
    async fetchSumIncome() {
      axios
        .get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/sum-all-income"
        )
        .then((response) => {
          this.sum_incomes = response.data.sum_income;
        })
        .catch((error) => {
          console.error("There was an error fetching the count:", error);
        });
    },

    // for Admin
    async fetchIncome() {
      try {
        const response = await axios.get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/all-income"
        );
        if (Array.isArray(response.data)) {
          this.income_datas = response.data;
        } else {
          console.error("Invalid response format:", response.data);
          this.showErrorMessage();
        }
      } catch (error) {
        console.error("Error fetching note:", error);
        this.showErrorMessage();
      }
    },
    async createIncome() {
      try {
        const response = await axios.post(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/create-income",
          {
            income: this.income,
            income_reason: this.income_reason,
            m_status: this.m_status,
            timestamp: this.timestamp,
          }
        );
        console.log(response.data);
        // alert('Employee added successfully');
        this.showSuccessMessage();
        // Optionally, you can fetch the updated list of sale employees after adding a new employee
        this.fetchIncome();
        this.resetNote_Form();
      } catch (error) {
        console.error("Error creating note:", error);
        // alert('Failed to create employee');
        this.showErrorMessage();
      }
    },

    // Other methods...
  },
};
</script>
